const Score = ({ value, className }) => {
  if (!value) return <div />

  return (
    <div
      data-testid="scoreDisplay"
      className={`
          min-h-[22.4px] leading-[16px] shrink-0
          inline-flex justify-center ml-[8px] text-black dark:text-white
          rounded-[32px] px-[12px] empty:hidden min-w-[43px] ${className}
          bg-transparent border-[1px] border-black dark:border-white text-black
        `}
    >
      <span className="leading-[20px] text-[14px]"> {Number.isInteger(value) ? value : value.toFixed?.(2)}</span>
    </div>
  )
}

export default Score
